((window, document) => {
    const section = document.querySelector('.js--cta')

    if (!section)
        return

    const media = section.querySelector('.cta__media')

    // without a media there is nothing to hold still
    if (!media)
        return

    const canPin = Boolean(window.matchMedia)
        && Boolean(window.CSS && window.CSS.supports)
        && window.CSS.supports('position', 'sticky')
        && window.CSS.supports('overflow-x', 'clip')
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (!canPin)
        return

    document.documentElement.classList.add('cta-pinned')
    section.classList.add('cta_pinned')

    const above = section.previousElementSibling

    const pin = above && above.classList.contains('tab-content')
        ? above.querySelector('.tab-content__pin')
        : null

    let ticking = false

    /**
    * Ease In Out
    * @param  {Number} value 0 - 1
    * @return {Number}
    */
    function easeInOut (value) {
        return (value < 0.5)
            ? (4 * value * value * value)
            : (1 - (Math.pow((-2 * value) + 2, 3) / 2))
    }

    /**
    * Paint the Slide for the Current Scroll Position
    * @return {Void}
    */
    function paint () {
        ticking = false

        // scroll alone moves it linearly; the offset bends that to ease-in-out
        if (pin && above.classList.contains('tab-content_pinned')) {
            const slide = pin.offsetHeight

            // untransformed position
            const natural = above.getBoundingClientRect().bottom - slide

            const progress = Math.min(Math.max(
                (slide - natural) / slide, 0), 1)

            const offset = (progress > 0 && progress < 1)
                ? (slide * (progress - easeInOut(progress)))
                : 0

            section.style.transform = offset
                ? `translate3d(0, ${offset.toFixed(1)}px, 0)`
                : ''
        }
    }

    /**
    * Queue a Paint on the Next Frame
    * @return {Void}
    */
    function request () {
        if (ticking)
            return

        ticking = true

        window
            .requestAnimationFrame(paint)
    }

    paint()

    window
        .addEventListener('scroll',
            request)

    window
        .addEventListener('resize',
            request)
})(window, document)
